const baseURL = 'https://tienda.sistemasdae.com/';
/* const baseURL = 'https://tienda.encatalogo.com/'; */

export default baseURL;
